import { useEffect, useRef, useState } from 'react'

type Timeout = ReturnType<typeof setTimeout>

export function useDebouncedAsyncProperty<T>(
  propertyValue: T,
  changePropertyValue: (value: T) => Promise<unknown>,
  delay = 2000,
) {
  const [value, setValue] = useState(propertyValue)
  const timeoutRef = useRef<Timeout | null>()

  useEffect(() => setValue(propertyValue), [propertyValue])

  const onChange = (value: T) => {
    setValue(value)
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    timeoutRef.current = setTimeout(
      () => changePropertyValue(value).catch(() => setValue(propertyValue)),
      delay,
    )
  }

  return [value, onChange] as const
}
